import api, { UPLOAD_API } from "../axiosInstance";

export const paymentService = {
  fetchPaymentDetails: (id) => api.get(`/payment/c2b/${id}`),
  submitPaymentForm: (data) => api.put("/payment/c2b", data),
  modifyPaymentStatus: (data) => api.put("/payment/c2b/status", data),
  fetchDownloadLink: (path) => UPLOAD_API.get(`/api/v1/file/preSigned?filePath=${path}`)
};
